import React from "react";
import "./selectOption.css";

const SelectItem = ({
  values,
  handleSelectData,
  selectNum,
  label,
  defaultValue,
  selectPlaceholder,
  handleBlur,
  style,
}) => {
  // Find the matching status name for the default value
  const defaultLabel = values.find(item => item[selectNum] === defaultValue)?.[label];

  return (
    <div className="selectData">
      <select
        value={defaultValue || ""}
        onChange={handleSelectData}
        style={style}
        onBlur={handleBlur}
      >
        {!defaultValue && <option value="">{selectPlaceholder}</option>}
        {values.map((item) => (
          <option key={item[selectNum]} value={item[selectNum]}>
            {item[label]}
          </option>
        ))}
      </select>
    </div>
  );
};
export default SelectItem;
